import { useEffect, useState } from 'react';

/**
 * Valore che insegue `value` con un ritardo.
 *
 * Serve alla ricerca: ogni tasto premuto sarebbe una chiamata a SharePoint, che
 * per giunta la contabilizza sul rate limit di Graph. Il ritardo si azzera se il
 * valore torna vuoto, così annullare la ricerca è immediato.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (value === '' || value === null || value === undefined) {
      setDebounced(value);
      return;
    }
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
